import { Shipment } from "@shared/ShipmentTypes";
import axios from "axios";

export const validateShipment = async (shipment: Shipment) => {
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/validate/shipment`, shipment);
    return response.data;
}